import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SvgIconModule } from '../svg-icon/svg-icon.module';
import { TranslateModule } from '@ngx-translate/core';
import { GenesysEmailOutgoingHeaderComponent } from './genesys-email-outgoing-header.component';
import { FormsModule } from '@angular/forms';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule.forChild(),
    SvgIconModule,
    FormsModule
  ],
  providers: [],
  declarations: [
    GenesysEmailOutgoingHeaderComponent
  ],
  exports: [
    GenesysEmailOutgoingHeaderComponent
  ]
})
export class GenesysEmailOutgoingHeaderModule {}
